<template>
<div class='bodyer news item'>
    <div class='yi-title-nav'>
        <div class='container'>
            <div class='row'>
                <div class='col-md-2 title'>
                    <i class='icon iconfont icon-xinwen float-left'></i>新闻
                </div>
            </div>
        </div>
    </div>

    <article>
        <div class='container'>
            <div class='news' v-if='news'>
                <div class='title'>{{news.title}}</div>
                <div class='info row'>
                    <div class='col-md-2 data'>{{news.created_at}}</div>
                </div>
                <div class='text' v-html='news.content'>
                    1234567
                </div>
            </div>
        </div>
    </article>
</div>
</template>

<script type="text/javascript">
import Common from '@/common/Common'
import Request from '@/common/Request'
import Notify from '@/common/Notify'
export default {
    data : function(){
        return {
            'news' : false
        }
    },
    created : function(){
        window.scrollTo(0, 0)
        var id = Common.getUrlParam('id')
        if(!id){
            Notify.error('链接无效!')
            Common.toUrl('/')
            return false
        }
        var url = Request.createApi('/app/news/list?where[id]='+id)
        Request.get(url, res => {
            if(!res.list[0]){
                Notify.error('链接无效!')
                Common.toUrl('/')
                return false
            }
            this.news = res.list[0]
        })
    }
}
</script>


// WEBPACK FOOTER //
// src/components/news/Item.vue